import { render, staticRenderFns } from "./FeaturedSpeciality.vue?vue&type=template&id=704e4d1c&"
import script from "./FeaturedSpeciality.vue?vue&type=script&lang=js&"
export * from "./FeaturedSpeciality.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports